import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const SECOND = () => {
  return (
    <CardSection id="SECOND" title="SECOND">
      <Paragraph>날짜/시간 초를 추출합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SECOND(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 초를 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>SECOND(`DATE`)</Paragraph>
        <Img src="computeSecond" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체 혹은 날짜/시간 객체를
          포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>반환하는 값의 범위는 0부터 59까지 입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
